module.exports = __webpack_public_path__ + "static/screen-web@2x-5e16c0cc93201f283eb7a0ebdff01d50.webp";